/*eslint-disable */
import root from '../../_helpers/roots';
import axios from 'axios';
import {
  mapGetters,
  mapState
} from 'vuex';
var $ = window.jQuery = jQuery = require('jquery');
import toast from '../../services/toast';

export default {
  name: 'myquiz',
  components: {},
  props: [],
  data() {
    return {
      quizList: [],
      nextStep: ""
    }
  },
  computed: {},
  mounted() {
    this.getQuizList()
  },
  methods: {
    getQuizList: function() {
      $('.quizloader').show();
      let quizHistoryLink = root.quizHistoryLink.link + '?course=' + this.$route.params.courseId;
      axios.get(quizHistoryLink).then(response => {
        if (response.status === 200) {
          this.quizList = response.data.data.results;
          if (response.data.data.next != null) {
            this.nextStep = response.data.data.next;
          }
          $('.quizloader').hide();
        }
      }).catch(err => {
        console.error(err);
        $('.quizloader').hide();
      })
    },
    loadmoreQuiz(url) {
      $('.quizloader').true();
      axios.get(url)
        .then((response) => {
          console.log(response)
          this.quizList = response.data.data.results;
          if (response.data.data.next != null) {
            this.nextStep = response.data.data.next;
          }
        });
    },
  },
}